/* eslint-disable max-lines-per-function */
import React, { useEffect, useRef, useState } from 'react';
import { MultiSelect } from 'primereact/multiselect';
import { Dropdown } from 'primereact/dropdown';
import { IoMdAddCircleOutline } from 'react-icons/io';
import { AiOutlineCheck } from 'react-icons/ai';

import './regular-pagamento.css';
import ReactInputMask from 'react-input-mask';
import cidadesEstadosService from '../../services/cidades-estados/cidades-estados-service';
import RestricaoTipoPagamentoService from '../../services/restricaoTipoPagamento';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { MdDeleteForever, MdList } from 'react-icons/md';
import { lerPlanilha } from '../../modulos/excel/ler-planilha';
import { TiDelete } from 'react-icons/ti';
import { FiSend } from 'react-icons/fi';
import DialogSuccessNoReload from '../dialogs/dialog-sucesso-sem-reload';
import DialogErrorNoReload from '../dialogs/dialog-error-sem-reload';
import { ProgressSpinner } from 'primereact/progressspinner';
import ModalVisualisarImpactados from './components/ModalVisualisarImpactados.jsx';
import { montarQueryParams } from './helpers/queryParamsDinamico';
import { decriptObjectOnLocalStorage } from '../../modulos/cripotografia/criptoStorage';

export default function RegularPagamentos() {
    const dt = useRef(null);
    const readCsv = useRef(null);

    const [globalFilter, setGlobalFilter] = useState();

    const [progressForm, setProgressForm] = useState(1);
    const [formaPagamento, setFormaPagamento] = useState([]);
    const [formaClientes, setFormaClientes] = useState('');

    const [estadoSelecionado, setEstadoSelecionado] = useState([]);
    const [cidadeSelecionada, setCidadeSelecionada] = useState();
    const [planosSelecionados, setPlanosSelecionados] = useState([]);
    const [inscricaoSelecionada, setInscricaoSelecionada] = useState('');
    const [quantidadeSelecionada, setQuantidadeSelecionada] = useState('');
    const [inscricoesSelecionadas, setInscricoesSelecionadas] = useState([]);
    const [inscricoesSelecionadasFiltro, setInscricoesSelecionadasFiltro] = useState([]);
    const [filtroInscricoes, setFiltroInscricoes] = useState('');

    const [loadingRequest, setLoadingRequest] = useState(false);
    const [loadingVisualizar, setLoadingVisualizar] = useState(false);
    const [openDialogSuccess, setOpenDialogSuccess] = useState(false);
    const [openDialogError, setOpenDialogError] = useState(false);
    const [modalVisualizar, setModalVisualizar] = useState(false);
    const [afetadosRestricao, setAfetadosRestrincao] = useState([]);
    const [inputsClicados, setInputClicados] = useState({});

    const [estados, setEstados] = useState();
    const [cidades, setCidades] = useState([]);
    const [planos, setPlanos] = useState([]);
    const [formasPagamento, setFormasPagamento] = useState([]);

    const [configuracoesSelecionadas, setConfiguracoesSelecionadas] = useState([]);

    const statesMonitorados = [formaPagamento, estadoSelecionado, cidadeSelecionada, planosSelecionados, formaClientes, quantidadeSelecionada, inscricoesSelecionadas];

    const opcoesClientes = [
        { label: 'Todos os Clientes',
            value: 'Todos' },
        { label: 'Quantidade',
            value: 'Quantidade' },
        { label: 'por Inscrição',
            value: 'Inscricao' }
    ];

    useEffect(() => {
        const loadPlanos = async () => {
            let planosCarregados = (await cidadesEstadosService.getPlanos()).map(item => item.plano.trim());

            planosCarregados = [...new Set(planosCarregados)].map(item => ({ label: item.toUpperCase(),
                value: item }));
            setPlanos([{ label: 'Todos Planos',
                value: 'Todos Planos' }, ...planosCarregados]);
        };

        const loadEstados = async () => {
            const estadosCarregados = (await cidadesEstadosService.getEstadosBrasil()).map(item => ({ label: item.nome,
                value: item.sigla }));

            setEstados([{ label: 'Todos Estados',
                value: 'Todos Estados' }, ...estadosCarregados]);
        };

        const loadFormasPagamento = async () => {
            const formasPagamentoCarregados = (await RestricaoTipoPagamentoService.getTiposPagamentos()).map(item => ({ label: item.descricao,
                value: { label: item.descricao,
                    id: item.id } }));

            setFormasPagamento([...formasPagamentoCarregados]);
        };

        loadFormasPagamento();
        loadPlanos();
        loadEstados();
    }, []);

    useEffect(() => {
        const loadCidades = async () => {
            const cidadesCarregadas = (await cidadesEstadosService.getCidadesEstado(estadoSelecionado[0])).map(item => ({ label: item.nome,
                value: { label: item.nome,
                    id: item.id } }));

            setCidades([{ label: 'Todas Cidades',
                value: { label: 'Todas Cidades',
                    id: '0' } }, ...cidadesCarregadas]);
        };

        if (estadoSelecionado[0] !== 'Todos Estados' && estadoSelecionado.length === 1) {
            loadCidades();
        }
    }, [estadoSelecionado]);

    useEffect(() => {
        const calcularPorcentagemIndividual = () => {
            let etapas = statesMonitorados.length - 3;

            if (estadoSelecionado[0] === 'Todos Estados' || estadoSelecionado.length > 1) {
                --etapas;
            }

            if (formaClientes === 'Inscricao') {
                return 50;
            }

            if (formaClientes === 'Quantidade') {
                ++etapas;
            }

            return 100 / etapas;
        };

        const calcularProgresso = async () => {
            const porcentagemIndividual = calcularPorcentagemIndividual();

            let porcentagemAtual = 0;

            for (const state of statesMonitorados) {
                if (Array.isArray(state)) {
                    if (state.length !== 0) {
                        porcentagemAtual += porcentagemIndividual;
                    }
                }

                if (typeof state === 'string') {
                    if (state) {
                        switch (state) {
                        case 'Quantidade':
                            if (quantidadeSelecionada && quantidadeSelecionada.trim()) {
                                porcentagemAtual += porcentagemIndividual;
                            }

                            break;
                        case 'Inscricao':
                            if (inscricoesSelecionadas.length > 0) {
                                porcentagemAtual += porcentagemIndividual;
                            } else {
                                porcentagemAtual = 50;
                            }

                            break;
                        case 'Todos:':
                            porcentagemAtual += porcentagemIndividual;
                            break;
                        }
                    }
                }
            }

            if (porcentagemAtual > 1) {
                setProgressForm(porcentagemAtual);
            }
        };

        calcularProgresso();
    }, [...statesMonitorados]);

    useEffect(() => {
        const clearCidades = async () => {
            setCidadeSelecionada();
        };

        clearCidades();
    }, [cidades, estadoSelecionado]);

    useEffect(() => {
        const filtrarInscricoesSelecionadas = () => {
            const inscricoesFiltradas = inscricoesSelecionadas.filter(inscricao => inscricao.includes(filtroInscricoes));

            setInscricoesSelecionadasFiltro(inscricoesFiltradas);
        };

        filtrarInscricoesSelecionadas();
    }, [filtroInscricoes, inscricoesSelecionadas]);

    const onSubmit = async () => {
        try {
            setLoadingRequest(true);

            const requisicao = configuracoesSelecionadas.map(configuracao => {
                const { formaPagamento, cidade, estado, plano, clientes, empresa } = configuracao;

                return {
                    formaPagamento: formaPagamento.map(forma => forma.id),
                    cidade: Array.isArray(cidade) ? cidade.map(cidade => cidade.id) : cidade,
                    estado,
                    plano,
                    inscricoes: Array.isArray(clientes) ? clientes : null,
                    clientes: !Array.isArray(clientes) ? clientes.replace('clientes', '').trim() : null,
                    empresa,
                    usuario: decriptObjectOnLocalStorage('IDuser')
                };
            });

            await RestricaoTipoPagamentoService.registrarRestricoesPagamento(requisicao);
            resetStates();
            setOpenDialogSuccess(true);
            setLoadingRequest(false);
        } catch (err) {
            setOpenDialogError(true);
            setLoadingRequest(false);
        }
    };

    const resetStates = () => {
        setFormaPagamento([]);
        setFormaClientes('');

        setEstadoSelecionado([]);
        setCidadeSelecionada([]);
        setPlanosSelecionados([]);
        setInscricaoSelecionada('');
        setQuantidadeSelecionada('');
        setInscricoesSelecionadas([]);
        setInscricoesSelecionadasFiltro([]);
        setFiltroInscricoes('');
        setProgressForm(1);
        deletarTudo();
    };

    const changeMultiSelect = (e, setter) => {
        if (e.value.length > 1) {
            const indexOpcaoTodos = e.value.findIndex(item => item.includes('Todos') || item.includes('Todas'));

            if (indexOpcaoTodos === 0) {
                e.value.splice(indexOpcaoTodos, 1);
            }

            if (indexOpcaoTodos > 0) {
                e.value = [e.value[indexOpcaoTodos]];
            }
        }

        setter(e.value);
    };

    const changeMultiSelectWithLabel = (e, setter) => {
        if (e.value.length > 1) {
            const indexOpcaoTodos = e.value.findIndex(item => item.label.includes('Todos') || item.label.includes('Todas'));

            if (indexOpcaoTodos === 0) {
                e.value.splice(indexOpcaoTodos, 1);
            }

            if (indexOpcaoTodos > 0) {
                e.value = [e.value[indexOpcaoTodos]];
            }
        }

        setter(e.value);
    };

    const addRestricao = () => {
        const restricaoPagamento = {
            formaPagamento,
            estado: estadoSelecionado,
            cidade: cidadeSelecionada,
            plano: planosSelecionados,
            clientes: formaClientes === 'Todos' ? 'Todos' : formaClientes === 'Quantidade' ? `${quantidadeSelecionada} clientes` : inscricoesSelecionadas
        };

        if (!checarSeExiste(restricaoPagamento)) {
            if (Array.isArray(restricaoPagamento.clientes)) {
                setConfiguracoesSelecionadas([...configuracoesSelecionadas, { formaPagamento: restricaoPagamento.formaPagamento,
                    clientes: restricaoPagamento.clientes }]);
            } else {
                setConfiguracoesSelecionadas([...configuracoesSelecionadas, restricaoPagamento]);
            }

            limparAposAdicao();
        }
    };

    const addInscricao = inscricao => {
        const existeInscricao = inscricoesSelecionadas.find(item => item === inscricao);

        if (!existeInscricao) {
            setInscricoesSelecionadas([...inscricoesSelecionadas, inscricao]);
            setInscricaoSelecionada('');
        }
    };

    const deleteInscricao = inscricao => {
        setInscricoesSelecionadas(inscricoesSelecionadas.filter(item => item !== inscricao));
    };

    const limparAposAdicao = () => {
        setInscricaoSelecionada('');
        setInputClicados({});
        setInscricoesSelecionadas([]);
    };

    const checarSeExiste = configuracao => {
        if (configuracoesSelecionadas.length === 0) {
            return false;
        }

        for (const item of configuracoesSelecionadas) {
            if (JSON.stringify(item) === JSON.stringify(configuracao)) {
                return true;
            }

            if (Array.isArray(item.clientes)) {
                if (item.formaPagamento === configuracao.formaPagamento && JSON.stringify(item.clientes) == JSON.stringify(configuracao.clientes)) {
                    return true;
                }
            }
        }

        return false;
    };

    const deletarPlano = plano => {
        const indexConfiguracao = configuracoesSelecionadas.indexOf(plano);

        setConfiguracoesSelecionadas(configuracoesSelecionadas.filter((element, index) => index !== indexConfiguracao));
    };

    const deletarTudo = () => {
        setConfiguracoesSelecionadas([]);
    };

    const deletarTodasInscricoes = () => {
        setInscricoesSelecionadas([]);
    };

    const importCsv = async e => {
        try {
            const planilha = await lerPlanilha(e.target.files[0]);
            const inscricoes = [];

            for (const linha of planilha) {
                if (linha.Inscricao) {
                    inscricoes.push(linha.Inscricao);
                }
            }

            setInscricoesSelecionadas([...new Set([...inscricoesSelecionadas, ...inscricoes])]);
            readCsv.current.value = null;
        } catch (err) {
            console.log(err);
        }
    };

    const makeArrayString = array => {
        let primeiro = true;
        let arrayString;

        if (!Array.isArray(array) || array.length === 0) {
            return '*';
        }

        for (const [index, item] of array.entries()) {
            if (primeiro) {
                arrayString = item;
                primeiro = false;
            } else if (index === 15) {
                arrayString = `${arrayString  }... + ${array.length - 15} registro(s)`;

                return arrayString;
            } else {
                arrayString = `${arrayString  }, ${item}`;
            }
        }

        return arrayString;
    };

    const makeArrayStringComLabel = array => {
        let primeiro = true;
        let arrayString;

        if (!Array.isArray(array) || array.length === 0) {
            return '*';
        }

        for (const [index, item] of array.entries()) {
            if (primeiro) {
                arrayString = item.label;
                primeiro = false;
            } else if (index === 15) {
                arrayString = `${arrayString  }... + ${array.length - 15} registro(s)`;

                return arrayString;
            } else {
                arrayString = `${arrayString  }, ${item.label}`;
            }
        }

        return arrayString;
    };

    const renderHeader = () => (
        <div className="header-table-cadastro-edicao-precos">
            <div className='title-header-table-cadastro'>
                <h2>Restrições Selecionadas</h2>
                <p>Todos os métodos abaixo serão bloqueados</p>
            </div>
            <div className='menu-header-table-cadastro'>
                <input placeholder='Faça uma busca global' value={globalFilter} onChange={e => setGlobalFilter(e.target.value)} className='input-empty' />
                <button disabled={configuracoesSelecionadas.length === 0} onClick={deletarTudo}>
                    <MdDeleteForever size={20} color='white' />
                    <span>Deletar tudo</span>
                </button>
            </div>
        </div>
    );

    const actionBodyTemplate = rowData => (
        <div className="actions-table-cadastro-edicao-precos">
            <button onClick={() => deletarPlano(rowData)} >
                <MdDeleteForever size={18} />
                <span>Deletar</span>
            </button>
        </div>
    );

    const estadosbodyTemplate = rowData => (
        <span>{makeArrayString(rowData.estado)}</span>
    );

    const formaPagamentosbodyTemplate = rowData => (
        <span>{makeArrayStringComLabel(rowData.formaPagamento)}</span>
    );

    const planosbodyTemplate = rowData => (
        <span>{makeArrayString(rowData.plano)}</span>
    );

    const cidadesBodyTemplate = rowData => (
        <span>{makeArrayStringComLabel(rowData.cidade)}</span>
    );

    const clientesbodyTemplate = rowData => (
        <span>{Array.isArray(rowData.clientes) ? makeArrayString(rowData.clientes) : rowData.clientes}</span>
    );

    useEffect(() => {
        (async () => {
            const queryParams = await montarQueryParams(planosSelecionados, cidadeSelecionada, estadoSelecionado);

            setLoadingVisualizar(true);

            const responseVisualizar = await RestricaoTipoPagamentoService.getAssociadosAfetadosRestricao(queryParams);

            setAfetadosRestrincao(responseVisualizar);
            setLoadingVisualizar(false);
        })();

        return () => {
            modalVisualizar && setModalVisualizar(false);
        };
    }, [modalVisualizar]);

    const visualizarInscricoesSelecionadas = async () => {
        setModalVisualizar(true);
    };

    return (
        <div className='page-regular-pagamentos'>
            <div className="div-title-regular-precos">
                <h1>Restringir Forma de Pagamento</h1>
                <p>Defina configurações para restrição de pagamentos</p>
            </div>

            <div className='form-configuracoes-restricao-pagamentos'>
                <div className='progress-bar-regular-pagamentos'>
                    <div className='preenchimento-progress-bar-regular-pagamentos' style={{ width: `${progressForm}%` }}></div>
                </div>

                <div className='row-form-configuracoes-restricao-pagamentos' >
                    <MultiSelect value={formaPagamento} options={formasPagamento} onChange={e => changeMultiSelectWithLabel(e, setFormaPagamento)}
                        filter={true} filterPlaceholder="Procurar" placeholder="Escolha uma forma de pagamento" className='select-cadastro-edicao-precos' disabled={loadingRequest} />
                </div>

                <div className='row-form-configuracoes-restricao-pagamentos' style={formaPagamento.length === 0 ? { display: 'none' } : {}}>
                    <Dropdown value={formaClientes} options={opcoesClientes} onChange={e => setFormaClientes(e.value)} placeholder="Selecione os Clientes" disabled={loadingRequest} />

                    <div className='div-input'>

                        {formaClientes === 'Quantidade' &&
              <>
                  {quantidadeSelecionada && quantidadeSelecionada.trim() &&
                  <p className='label-ok'> Quantidade de clientes <AiOutlineCheck size={15} color='green' style={{ margin: '0 0 0 5px' }} /></p>
                  }
                  <ReactInputMask mask='99999' maskChar={' '} placeholder='Quantidade de clientes' onBlur={() => setInputClicados({ ...inputsClicados,
                      quantidadeClientes: true })} className={!inputsClicados.quantidadeClientes ? 'input-empty' : quantidadeSelecionada.trim() ? 'input-ok' : 'input-wrong'} value={quantidadeSelecionada} onChange={e => setQuantidadeSelecionada(e.target.value)} disabled={loadingRequest}></ReactInputMask>
                  {inputsClicados.quantidadeClientes && !quantidadeSelecionada.trim() &&
                  <p className='error-input'>É necessário inserir a quantidade de clientes</p>}
              </>
                        }

                        {formaClientes === 'Inscricao' &&
              <>
                  {inscricaoSelecionada && inscricaoSelecionada.trim() &&
                  <p className='label-ok'> Inscrição <AiOutlineCheck size={15} color='green' style={{ margin: '0 0 0 5px' }} /></p>
                  }
                  <ReactInputMask mask='99999999' maskChar={' '} placeholder='Inscrição' onBlur={() => setInputClicados({ ...inputsClicados,
                      inscricao: true })} className={!inputsClicados.inscricao ? 'input-empty' : inscricaoSelecionada.trim() ? 'input-ok' : 'input-empty'} value={inscricaoSelecionada} onChange={e => setInscricaoSelecionada(e.target.value)} disabled={loadingRequest}></ReactInputMask>

              </>
                        }

                    </div>

                    {formaClientes === 'Inscricao' &&
            <>
                <button className='button-form' onClick={() => addInscricao(inscricaoSelecionada)} disabled={!inscricaoSelecionada.trim() || loadingRequest}>
                    <span>Adicionar Inscrição</span>
                </button>

                <div className='botoes-acoes-inscricoes'>

                    <div className='import-excel-button' style={loadingRequest ? { backgroundColor: 'rgb(142, 160, 180)',
                        cursor: 'not-allowed' } : {}}>
                        <input type="file"
                            accept=".csv"
                            onChange={importCsv}
                            ref={readCsv}
                            disabled={loadingRequest} />
                        <span>Importar inscrições via CSV</span>
                    </div>

                </div>
            </>
                    }

                </div>

                <div className='row-form-configuracoes-restricao-pagamentos' style={formaClientes === 'Inscricao' || !formaClientes ? { display: 'none' } : {}}>
                    <MultiSelect value={estadoSelecionado} options={estados} onChange={e => changeMultiSelect(e, setEstadoSelecionado)}
                        filter={true} filterPlaceholder="Procurar" placeholder="Escolha um Estado" className='select-cadastro-edicao-precos' disabled={loadingRequest} />
                    <MultiSelect value={cidadeSelecionada} options={cidades} onChange={e => changeMultiSelectWithLabel(e, setCidadeSelecionada)} disabled={estadoSelecionado.length === 0 || estadoSelecionado[0] === 'Todos Estados' || estadoSelecionado.length > 1 || loadingRequest}
                        filter={true} filterPlaceholder="Procurar" placeholder="Escolha uma Cidade" className='select-cadastro-edicao-precos' />
                    <MultiSelect value={planosSelecionados} options={planos} onChange={e => changeMultiSelect(e, setPlanosSelecionados)} disabled={!cidadeSelecionada && estadoSelecionado[0] !== 'Todos Estados' && estadoSelecionado.length <= 1 || loadingRequest}
                        filter={true} filterPlaceholder="Procurar" placeholder="Escolha um Plano" className='select-cadastro-edicao-precos' />
                    {formaClientes !== 'Quantidade' && <button disabled={progressForm < 100 || loadingRequest} onClick={visualizarInscricoesSelecionadas} className="button-visualizar-lista">
                        <MdList size={20} />
                        <span className="visualizar-lista">Visualizar</span>
                    </button>
                    }
                </div>

                {inscricoesSelecionadas.length > 0 && formaClientes === 'Inscricao' &&
          <div className='exibicao-inscricoes'>
              {(inscricoesSelecionadas.length > 15 || filtroInscricoes) &&
              <div className='acoes-exibicao-inscricoes'>
                  <input placeholder='Buscar inscrição' className='input-empty' value={filtroInscricoes} onChange={e => setFiltroInscricoes(e.target.value)} />
                  <button className='button-delete' disabled={inscricoesSelecionadas.length === 0 || loadingRequest} onClick={deletarTodasInscricoes} >
                      <MdDeleteForever size={20} color='white' />
                      <span>Deletar tudo</span>
                  </button>
              </div>}

              {filtroInscricoes ?
                  <>
                      {inscricoesSelecionadasFiltro.length > 0 ?
                          <>
                              {inscricoesSelecionadasFiltro.map(((item, index) =>
                                  <div className='item-exibicao-inscricoes' key={index}>
                                      <span>{item}</span>
                                      <button onClick={() => deleteInscricao(item)}>
                                          <TiDelete color='white' size={25} />
                                      </button>
                                  </div>
                              ))}
                          </>                  :
                          <div className='sem-resultados-filtro'>
                              <span> Sem resultados para o filtro aplicado</span>
                          </div>
                      }
                  </>              :
                  <>
                      {inscricoesSelecionadas.map(((item, index) =>
                          <div className='item-exibicao-inscricoes' key={index}>
                              <span>{item}</span>
                              <button onClick={() => deleteInscricao(item)}>
                                  <TiDelete color='white' size={25} />
                              </button>
                          </div>
                      ))}
                  </>
              }
          </div>}

                <div className='actions-form-configuracoes-pagamento'>
                    <button type='submit' className='form-configuracoes-restricao-pagamentos-button' onClick={addRestricao}
                        disabled={progressForm < 100 || loadingRequest}>
                        <IoMdAddCircleOutline size={25} color='white' />
                        <span>Adicionar</span>
                    </button>
                </div>

            </div>

            <div className='table-restricao-pagamentos'>
                <DataTable ref={dt} value={configuracoesSelecionadas} loading={loadingRequest}
                    responsive dataKey="Referencia" rowHover globalFilter={globalFilter} header={renderHeader()}
                    paginator rows={5} emptyMessage="Ainda não há restrições selecionadas" currentPageReportTemplate="Exibindo {first} a {last} de {totalRecords} resultados encontrados"
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown" rowsPerPageOptions={[5, 10]}>
                    <Column field="formaPagamento.label" header="Forma de Pagamento" body={formaPagamentosbodyTemplate} filter filterPlaceholder="Buscar forma de pagamento dentre as selecionadas" />
                    <Column field="estado" header="Estado" body={estadosbodyTemplate} filter filterPlaceholder="Buscar estado dentre os selecionados" />
                    <Column field="cidade.label" header="Cidade" body={cidadesBodyTemplate} filter filterPlaceholder="Buscar cidade dentre as selecionadas" />
                    <Column fild='plano' header="Plano" body={planosbodyTemplate} filter filterPlaceholder="Buscar plano dentre os selecionados" />
                    <Column field="clientes" header="Clientes" body={clientesbodyTemplate} filter filterPlaceholder="Buscar plano dentre os selecionados" />
                    <Column body={actionBodyTemplate} headerStyle={{ width: '8em',
                        textAlign: 'center' }} bodyStyle={{ textAlign: 'center',
                        overflow: 'visible' }} />
                </DataTable>
            </div>

            <div className='acoes-submit'>
                <button type='submit' onClick={onSubmit} disabled={loadingRequest} className='form-configuracoes-restricao-pagamentos-button' style={configuracoesSelecionadas.length === 0 ? { display: 'none' } : {}}>
                    {
                        !loadingRequest ?
                            (
                                <>
                                    <FiSend size={20} color='white' />
                                    <span>Enviar Restrições</span>
                                </>
                            ) : (

                                <div className="progress-request">
                                    <ProgressSpinner style={{ width: '20px',
                                        heigth: '20px',
                                        margin: '0',
                                        padding: '0' }} />
                                    <span style={{ marginLeft: '5px' }}>Enviando Restrições...</span>
                                </div>
                            )
                    }
                </button>

            </div>
            <ModalVisualisarImpactados loadingTable={loadingVisualizar} arrayImpactados={afetadosRestricao} fecharModalAviso={setModalVisualizar} isVisible={modalVisualizar} />
            <DialogSuccessNoReload messageHeader='Restrições realizadas com sucesso!' messageBody='Todas as alterações foram salvas!' openDialog={openDialogSuccess} setOpenDialog={setOpenDialogSuccess} />
            <DialogErrorNoReload messageHeader='Nenhuma alteração realizada!' messageBody='Houve um problema ao salvar as alterações, tente novamente!' openDialog={openDialogError} setOpenDialog={setOpenDialogError} />
        </div>
    );}
